import { StundenpensumMonat } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/StundenpensumMonat';
import { StundenpensumWoche } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/StundenpensumWoche';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';

export function Sollstunden() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;
  return (
    <div className="py-2 grid grid-cols-2 gap-y-4 text-neutrals-800 leading-5 text-sm font-normal">
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.sollstunden.label',
        )}
      </span>
      <span className="text-neutrals-900 font-semibold">
        {t(
          `domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.sollstunden.zusammenfassung.${data.bezahlung.sollstunden.sollstunden ? 'ja' : 'nein'}`,
        )}
      </span>
      {data.bezahlung.sollstunden.sollstunden &&
        data.bezahlung.sollstunden.stundenpensum === 'monat' && (
          <StundenpensumMonat />
        )}
      {data.bezahlung.sollstunden.sollstunden &&
        data.bezahlung.sollstunden.stundenpensum === 'woche' && (
          <StundenpensumWoche />
        )}
    </div>
  );
}
